export default class AlreadyExistsProfileError extends Error {
  constructor(details?: Error) {
    super('Não é possível criar um perfil já existente', { cause: details });
  }
}
